// A dedicated Action Cable consumer that connects to the BIGDATA app's cable
// (the folder/upload status broadcasts originate there, not on this app).
// Keep this URL in sync with BigdataApiService::BASE_URL host.
import { createConsumer } from "@rails/actioncable"

// URL is injected by the server (see the "bigdata-cable-url" meta tag in the
// layout), driven by ENV["BIGDATA_CABLE_URL"] so it can point at the bigdata
// app's public host per environment. Falls back to localhost for dev.
const metaEl = document.querySelector('meta[name="bigdata-cable-url"]')
const BIGDATA_CABLE_URL = (metaEl && metaEl.content) || "ws://localhost:4000/cable"

export default createConsumer(BIGDATA_CABLE_URL)
